
import { Component, Vue } from "nuxt-property-decorator";
import BreadCrumb from "~/components/molecules/display/BreadCrumb.vue";
import WiderrufForm from "~/components/organisms/form/WiderrufForm.vue";
import { generateMetaTags } from "~/operations/meta-helper-functions";

@Component({
  scrollToTop: true,
  components: {
    BreadCrumb,
    WiderrufForm,
  },
})
export default class WiderrufPage extends Vue {
  get breadcrumbs() {
    return [{ name: "Vertrag widerrufen", linkUrl: "/pelletspreise/widerruf" }];
  }

  head() {
    return {
      ...generateMetaTags(this.$route.path, "widerruf-pellets"),
      link: [{ rel: "canonical", href: this.$route.path }],
    };
  }
}
